import { render, staticRenderFns } from "./LaudoSupressaoVegetal.vue?vue&type=template&id=274c8562&scoped=true&lang=pug"
import script from "./LaudoSupressaoVegetal.vue?vue&type=script&lang=js"
export * from "./LaudoSupressaoVegetal.vue?vue&type=script&lang=js"
import style0 from "./LaudoSupressaoVegetal.vue?vue&type=style&index=0&id=274c8562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c8562",
  null
  
)

export default component.exports